import React from 'react';
import { useParams } from 'react-router-dom';

import RevenuePage from '../../../manager/financial/revenue';

interface ParamTypes {
  id: string
}

const page = () => {
  const { id } = useParams<ParamTypes>();

  return <RevenuePage subsidiaryId={id} />;
};

export default page;
